import { render, staticRenderFns } from "./customsReceiptRecordDialog.vue?vue&type=template&id=e16088f6&"
import script from "./customsReceiptRecordDialog.vue?vue&type=script&lang=js&"
export * from "./customsReceiptRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e16088f6')) {
      api.createRecord('e16088f6', component.options)
    } else {
      api.reload('e16088f6', component.options)
    }
    module.hot.accept("./customsReceiptRecordDialog.vue?vue&type=template&id=e16088f6&", function () {
      api.rerender('e16088f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/customsReceiptRecordDialog.vue"
export default component.exports